<template lang="pug">
  .flow-builder-action-edit-order
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="platform in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Editar orden
        p.text-secondary.text-sm Te permite modificar productos o agregar descuentos a la orden del usuario.
        result-description.mb-3(variable-name="product", variable-type="object")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label-size="sm", label="Acción:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'action'")
            b-form-select(size="sm", :options="actionTypes" :value="template_attribute.value || null", @change="update(template_attribute, $event)", :disabled="disabled",)
              template(#first)
                b-form-select-option(:value="null", disabled ) -- Acción a realizar --
          div(v-if="actionType === 'edit'")
            b-form-group(label-size="sm", label="Id del producto:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'product_id'")
              vue-tribute(:options="tributeOpts")
                b-form-input.disabled-white(size="sm", placeholder="Id del producto", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
            b-form-group(label-size="sm", :label="`Cantidad a ${actionName}:`", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'quantity'")
              vue-tribute(:options="tributeOpts")
                b-form-input.disabled-white(size="sm", placeholder="Cantidad", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
            b-form-group(label-size="sm", label="Costo extra", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'extra_cost' && templateActionValue.value === 'add_product'")
              vue-tribute(:options="tributeOpts")
                b-form-input.disabled-white(size="sm", placeholder="Cantidad", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          div(v-else-if="actionType === 'discount'")
            b-form-group(label-size="sm", label="Descuento en porcentaje:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'percent_discount'")
              b-input-group(size="sm" )
                b-input-group-prepend
                  b-input-group-text
                    percent-icon.icon-sm
                vue-tribute(:options="tributeOpts", style="flex-grow:1;")
                  b-form-input.disabled-white(:value="template_attribute.value", placeholder="0", @blur="updateTemplateAttribute(template_attribute, $event)", style="border-top-left-radius:0;border-bottom-left-radius:0;")
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import ResultDescription from '@/components/templates/helpers/ResultDescription.vue'
import templateCommon from '@/helpers/template-common'
import Connector from '@/components/templates/connectors/Connector.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
      actionTypes: [
        { text: 'Agregar producto', value: 'add_product' },
        { text: 'Quitar producto', value: 'remove_product' },
        { text: 'Limpiar orden', value: 'clear_order' },
        { text: 'Agregar descuento', value: 'add_discount' }
      ]
    }
  },
  computed: {
    templateActionValue () {
      const template_attribute = this.getAttribute('action')
      return template_attribute || {}
    },
    actionType () {
      const actionType = this.actionTypes.find(a => a.value === this.templateActionValue.value)
      if (!actionType) return ''

      switch (actionType.value) {
        case 'add_product':
        case 'remove_product':
          return 'edit'
        case 'clear_order':
          return 'clear'
        case 'add_discount':
          return 'discount'
        default:
          return ''
      }
    },
    actionName () {
      if (this.actionType === 'edit') {
        switch (this.templateActionValue.value) {
          case 'add_product':
            return 'agregar'
          case 'remove_product':
            return 'quitar'
          default:
            return ''
        }
      }

      return ''
    }
  },
  components: {
    'template-connector': Connector,
    ResultDescription,
    TemplateTools
  },
  methods: {
    update (template_attribute, value) {
      template_attribute.value = value
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute)

      this.$message.success('Actualizado')
    },
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const newValue = value.target._value

      this.update(template_attribute, newValue)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>
  .flow-builder-action-edit-order {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
